/*
 * @Descripttion:
 * @version:
 * @Author: Mao Jiaojiao
 * @Date: 2022-12-26 10:31:01
 * @LastEditors: Mao Jiaojiao
 * @LastEditTime: 2022-12-26 13:52:08
 */
import layout from '@/views/common/layout'
const indexRouter = [
    {
        path: '/index',
        component: layout,
        children: [
            {
                path: 'index',
                component: () => import('@/views/yd/index/index'),
                name: 'index',
                meta: { title: '首页', icon: '', affix: true }
              }
        ]
    }
    // {
    //     path: '/index',
    //     component: () => import('@/views/yd/index/index'),
    //     name: 'indexPage',
    //     meta: { title: '后台', icon: '', affix: true },
    // }
]

export default indexRouter



// WEBPACK FOOTER //
// ./src/router/modules/index.js